﻿import {
  Component,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectionStrategy,
  HostListener
} from '@angular/core';

@Component({
  selector: 'g[sk-bubble-chart-series-circle]',
  template: `
    <svg:circle
      [attr.cx]="cx"
      [attr.cy]="cy"
      [attr.r]="r"
      [attr.fill]="fill"
      [attr.stroke]="stroke"
      [attr.opacity]="circleOpacity"
      [attr.class]="classNames"
      [attr.pointer-events]="pointerEvents"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SkBubbleChartSeriesCircleComponent implements OnChanges {

  @Input() cx;
  @Input() cy;
  @Input() r;
  @Input() fill;
  @Input() stroke;
  @Input() data;
  @Input() classNames;
  @Input() circleOpacity;
  @Input() pointerEvents;

  @Output() select = new EventEmitter();
  @Output() activate = new EventEmitter();
  @Output() deactivate = new EventEmitter();

  // custom touch vs click handling

  isTouchedNotClicked: boolean;

  @HostListener('touchstart', ['true'])
  @HostListener('click', ['false'])
  onClick(isTouched) {
      if (isTouched) {
          this.isTouchedNotClicked = true;
          this.activate.emit(this.data);
          //console.log('touch');
      }
      else if (!this.isTouchedNotClicked) {
          this.isTouchedNotClicked = false;
          this.select.emit(this.data);
          //console.log('click');
      }
  }

  @HostListener('dblclick')
  onDoubleClick() {
      this.isTouchedNotClicked = false;
      this.select.emit(this.data);
  }

  //

  @HostListener('mouseenter')
  onMouseEnter(): void {
    this.activate.emit(this.data);
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
      this.isTouchedNotClicked = false;
      this.deactivate.emit(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.classNames = Array.isArray(this.classNames) ?
      this.classNames.join(' ') : 
      '';
    this.classNames += 'circle';
  }

}
